// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"Quotes_carouselWrapper__mzxtJ","carousel":"Quotes_carousel__yIT7o","quote":"Quotes_quote__WQh0I","cite":"Quotes_cite__-wdVb"};